import { createSelector } from '@reduxjs/toolkit'

import { ApplicationState } from 'redux/Stores/types'

// select config sections keyed by category
export const selectConfigsData = createSelector(
  [(state: ApplicationState) => state.ConfigStore.data],
  (data) => data
)

export const selectConfigsFetchStatus = createSelector(
  [(state: ApplicationState) => state.ConfigStore.fetchStatus],
  (fetchStatus) => fetchStatus
)
